import { render, staticRenderFns } from "./ProductDownload.vue?vue&type=template&id=660c1e1b"
import script from "./ProductDownload.vue?vue&type=script&lang=js"
export * from "./ProductDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports